import { createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "utils";
import { BASE_API_URL } from "../db";
import { showAlertAction } from "./alert";

const PAGE_SIZE = 10;

const slice = createSlice({
  name: "search",
  initialState: {
    query: "",
    results: [],
    hasMore: false,
    page: 1,
    loading: false,
    loadingMore: false,
  },
  reducers: {
    setSearchResults: (state, action) => {
      state.results = action.payload.results || [];
      state.hasMore = !!action.payload.has_more;
      state.page = action.payload.page || 1;
      state.query = action.payload.query ?? state.query;
    },
    appendSearchResults: (state, action) => {
      state.results = [...state.results, ...(action.payload.results || [])];
      state.hasMore = !!action.payload.has_more;
      state.page = action.payload.page || state.page;
    },
    setSearchLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSearchLoadingMore: (state, action) => {
      state.loadingMore = action.payload;
    },
    clearSearchResults: (state) => {
      state.results = [];
      state.hasMore = false;
      state.page = 1;
      state.query = "";
    },
  },
});

export default slice.reducer;

export const { clearSearchResults } = slice.actions;
const {
  setSearchResults,
  appendSearchResults,
  setSearchLoading,
  setSearchLoadingMore,
} = slice.actions;

const fetchSearchPage = (query, page) =>
  makeRequest(
    `${BASE_API_URL}/accounts/search/?q=${encodeURIComponent(
      query
    )}&page=${page}&page_size=${PAGE_SIZE}`,
    "GET"
  );

export const searchClientsAndGuarantors = (query) => async (dispatch) => {
  dispatch(setSearchLoading(true));
  try {
    const res = await fetchSearchPage(query, 1);
    dispatch(setSearchResults({ ...res, query }));
  } catch (error) {
    dispatch(
      showAlertAction({
        message: error?.message || "Unable to complete search",
        level: "danger",
        isVisible: true,
      })
    );
  } finally {
    dispatch(setSearchLoading(false));
  }
};

export const loadMoreSearchResults = (query, nextPage) => async (dispatch) => {
  dispatch(setSearchLoadingMore(true));
  try {
    const res = await fetchSearchPage(query, nextPage);
    dispatch(appendSearchResults(res));
  } catch (error) {
    dispatch(
      showAlertAction({
        message: error?.message || "Unable to load more results",
        level: "danger",
        isVisible: true,
      })
    );
  } finally {
    dispatch(setSearchLoadingMore(false));
  }
};
